<template>
  <div>
    <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;    display: flex;
    justify-content: space-between;">
      <v-flex xs12 sm12 md12 lg9>
        <v-expansion-panel class="mb-4">
          <v-expansion-panel-content>
            <template v-slot:header>
              <div>Filters</div>
            </template>
            <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;"
                      class="index_header">
              <v-flex sm3 md4 lg2 style="margin-right: 30px;">
                <v-checkbox
                    label="Published"
                    :value="filters.Published"
                    v-model="filters.Published"
                    @change="filterPublished($event)"
                    class="request_checkbox"
                    :color="'black'"
                ></v-checkbox>
              </v-flex>

              <v-flex sm3 md4 lg2 style="margin-right: 30px;">
                <v-checkbox
                    label="Archived"
                    :value="filters.Archived"
                    v-model="filters.Archived"
                    @change="filterArchived($event)"
                    class="request_checkbox"
                    :color="'black'"
                ></v-checkbox>
              </v-flex>

              <v-flex sm12 md6 lg6 style="margin-right: 30px;">
                <div class="flatpickr-wrapper">
                  <flat-pickr
                      class="flatpickerCSS2"
                      v-model="filters.affected_date"
                      :config="config3"
                      placeholder="Date"
                      name="Date" :menu-props="{closeOnContentClick:true}"/>
<!--                  <div class="close-button" @click="clearDate">X</div>-->
                </div>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <v-flex sx12 sm12 md12 lg3>
        <v-flex xs12 sm12 md12 lg12 style="display: flex; justify-content: center; padding-bottom: 27px;">
          <v-btn slot="activator" class="white--text add_announcement text-xs-center" style="padding: 22px;">
            <router-link to="/restricted-users" class="white--text">
              Restricted Users List
            </router-link>
          </v-btn>
        </v-flex>
      </v-flex>
    </v-layout>


    <v-data-table
        :headers="headers"
        :items="incidentList"
        class="elevation-1"
        v-model="incidentReport"
        item-key="id"
        :loading="loaders.incident_list_loader"
        :total-items="total_items"
        :pagination.sync="pagination"
        :rows-per-page-items="[10, 20, 50, 100]"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-justify">
          <v-avatar size="45" v-if="props.item.image_url">
            <v-img :src="storage_path1 + props.item.image_url"
                   @click="displayFullImage(props.item.image_url, 1)" alt="Incident image"></v-img>
          </v-avatar>
          <v-avatar size="45" v-else>
            <v-img :src="storage_path() + 'incident-report.jpg'"
                   @click="displayFullImage('incident-report.jpg', 0)"
                   alt="incident image"></v-img>
          </v-avatar>

        </td>

        <td class="text-xs-left" v-if="props.item.description">
          <router-link :to="{name:'incidentReportDetails',params:{id:props.item.id}}"><a>{{
              props.item.description.substring(0, 100) + "..." }}</a></router-link>
<!--          <a @click="activateShowDialog(props.item.id)">{{ props.item.description.substring(0, 100) + "..." }}</a>-->
        </td>
        <td v-else>{{ " - " }}</td>

        <td class="text-xs-left" v-if="props.item.incident_type.name"> {{ props.item.incident_type.name }}</td>
        <td v-else>{{ " - " }}</td>

        <td class="text-xs-left" v-if="props.item.station_name.name">{{ props.item.station_name.name }}</td>
        <td v-else>{{ " - " }}</td>

        <td class="text-xs-left" v-if="props.item.created_by_user.first_name">
          {{
            props.item.created_by_user.first_name +
            " " + props.item.created_by_user.last_name
          }}
        </td>
        <td v-else>{{ " - " }}</td>

        <td class="text-xs-left">
          <label class="switch">
            <input type="checkbox" v-model="props.item.publish_status"
                   @change="updateToggleStatus(props.item.publish_status, props.item.id)"/>
            <span class="slider round"></span>
          </label>
        </td>


        <td class="text-xs-left" v-if="props.item.created_at">
          {{ moment(props.item.created_at).format("YYYY-MM-DD HH:mm A") }}
        </td>
        <td v-else>{{ " - " }}</td>

        <td>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn
                  dark icon
                  style="color: white; background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%) !important"
                  v-on="on"
                  depressed>
                <span class="material-icons">more_vert</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="showIncident(props.item.id)" :disabled="!checkPermission('update-incident-report')">
                <v-list-tile-title>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on , attrs}">
                      <v-icon class="material-icons" color="primary" v-on="on">edit</v-icon>
                    </template>
                    <span>Edit Incident</span>
                  </v-tooltip>
                </v-list-tile-title>
              </v-list-tile>

              <v-list-tile
                  @click="delete_incident_box = !delete_incident_box; incident_id =
                       props.item.id;" :disabled="!checkPermission('update-incident-report')">
                <v-list-tile-title>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on , attrs}">
                      <v-icon class="material-icons" color="red" v-on="on">delete</v-icon>
                    </template>
                    <span>Delete Incident</span>
                  </v-tooltip>
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </td>

      </template>
    </v-data-table>

    <v-dialog v-model="image_dialog_box" width="180" height="180" max-width="200" max-height="200" hide-overlay
              color="white">
      <v-card elevation="0">
        <v-img v-if="flag == 0" :src="storage_path() + image_path"></v-img>
        <v-img v-if="flag == 1" :src="storage_path1 + image_path"></v-img>
      </v-card>
    </v-dialog>

    <!--    <v-dialog v-model="status_approval_dialog" max-width="500px">-->
    <!--      <v-card>-->
    <!--        <v-card-text>-->
    <!--          <v-layout row wrap>-->
    <!--            <v-card-title primary-title v-if="incident_status == 'Published'">-->
    <!--              <h2>Are you sure you wish to Publish this Incident ? </h2>-->
    <!--            </v-card-title>-->

    <!--            <v-card-title primary-title v-if="incident_status == 'Archived'">-->
    <!--              <h3>Are you sure you wish to Archive this Incident ? </h3>-->
    <!--            </v-card-title>-->
    <!--          </v-layout>-->
    <!--        </v-card-text>-->
    <!--        <v-card-actions>-->
    <!--          <v-spacer></v-spacer>-->
    <!--          <v-btn flat type="reset" small @click="status_approval_dialog = false; loaders.approvalLoader = false">Cancel-->
    <!--          </v-btn>-->
    <!--          <v-btn :loading="loaders.approvalLoader" :disabled="loaders.approvalLoader" color="primary" small-->
    <!--                 @click="updateStatus">Confirm-->
    <!--          </v-btn>-->
    <!--        </v-card-actions>-->
    <!--      </v-card>-->
    <!--    </v-dialog>-->


    <!--    dialog to edit hack-->
    <v-dialog v-model="update_incident_dialog" max-width="600px">
      <v-card>
        <v-form id="update_incident"
                @submit.prevent="validateBeforeSubmit('editIncident')"
                data-vv-scope="editIncident"
                ref="update_incident_form"
                v-model="valid">

          <v-card-title style="padding-bottom: 0px;">
            <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">
              <h4 class="heading_text">Update User Incident</h4>
              <v-btn icon @click="update_incident_dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md12 lg12>
                <label>Description: </label>
                <v-textarea
                    name="Description"
                    v-model="update_incident_object.description"
                    rows="5"
                    label="Description"
                    v-validate="'required'"
                    solo flat
                    :error-messages="errors.collect('editIncident.Description')">
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat type="reset" small @click="update_incident_dialog = false; loaders.updateLoader = false">Cancel
            </v-btn>
            <v-btn :loading="loaders.updateLoader" :disabled="loaders.updateLoader ||
          update_incident_object.description == ''"
                   color="primary" small @click="editIncident">Confirm
            </v-btn>
          </v-card-actions>

        </v-form>
      </v-card>
    </v-dialog>

    <!-- show incident details -->
    <v-dialog v-model="showIncidentDetailDialog" max-width="600px" scrollable>
      <v-card>
        <v-card-title>
          <v-flex xs12 md12 lg12 style="display: flex; justify-content: space-between;">
            <h2 class="heading" style="padding-bottom: 0px;">Incident Details</h2>

            <v-btn icon @click="showIncidentDetailDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px;">

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small
                 @click="showIncidentDetailDialog = false; loaders.updateLoader = false">Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--      delete Incident dialog-->
    <v-dialog v-model="delete_incident_box" scrollable :overlay="false" max-width="450px"
              transition="dialog-transition"
              hide-overlay persistent>
      <v-card>
        <v-card-title primary-title>
          <span>Are you sure you wish to delete this Incident?</span>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="error" @click="delete_incident_box = false">Cancel</v-btn>
          <v-btn small color="primary" @click="deleteIncident" :loading="loaders.delete_loading">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
        v-model="snackbar.display"
        :color="snackbar.color"
        :top="snackbar.top"
        :bottom="snackbar.bottom"
        :left="snackbar.left"
        :right="snackbar.right"
        :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <v-btn text dark @click="snackbar.display = false">
        <v-icon right color="white"> close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "index",
  components: {
    flatPickr
  },

  watch: {
    pagination: {
      handler() {
        this.getIncidentReports();
      },
    },
    "filters.affected_date": function (val) {
      if (val != null || val != '') {
        // this.filters.Published = false;
        // this.filters.Archived = false;
        this.filters.affected_date = val;
        this.getIncidentReports();
      }
    }
  },
  data() {
    return {
      status: [
        {
          text: 'Published',
          value: 'Published'
        },
        {
          text: 'Archived',
          value: 'Archived'
        }
      ],
      filters: {
        Published: false,
        Archived: false,
        affected_date: "",
      },
      loaders: {
        incident_list_loader: false,
        approvalLoader: false,
        updateLoader: false,
        delete_loading: false,
      },
      incidentList: [],
      total_items: 0,
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
      incidentReport: [],
      headers: [
        {
          text: 'Image',
          value: 'image',
          align: 'left',
          sortable: false
        },
        {
          text: 'Description',
          value: 'description',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Incident Type',
          value: 'incident_type',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Station Name',
          value: 'station_name',
          sortable: false,
          align: 'left',
        },
        {
          text: 'User Name',
          value: 'created_by',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Created At',
          value: 'created_at',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'left'
        }
      ],
      pagination: {sortBy: "created_at", descending: false, rowsPerPage: 10},
      image_dialog_box: false,
      image_path: 'incident-report.jpg',
      incident_status: '',
      incident_id: '',
      // status_approval_dialog: false,
      update_incident_object: [],
      show_incident_object: [],
      update_incident_dialog: false,
      showIncidentDetailDialog: false,
      valid: '',
      config3: {
        enableTime: false,
        altInput: true,
        dateFormat: "Y-m-d",
        time_24hr: false,
        maxDate: moment().format('YYYY-MM-DD'),
      },
      delete_incident_box: false,
      storage_path1: "",
      flag: 0,
      is_liked: 0,
    }
  },
  methods: {
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    filterPublished(value) {
      this.filters.Published = value;
      this.filters.Archived = false;
      this.filters.affected_date = "";
      this.getIncidentReports();
    },
    filterArchived(value) {
      this.filters.Published = false;
      this.filters.Archived = value;
      this.filters.affected_date = "";
      this.getIncidentReports();
    },
    getIncidentReports() {
      this.loaders.incident_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-incidents`, {
        params: this.pagination,
        headers: this.$headers,
      }).then((response) => {
        if (response.data.status == 1) {
          this.loaders.incident_list_loader = false;
          this.incidentList = response.data.data.data;

          this.incidentList.forEach(element => {
            if (element.publish_status == 'Published') {
              element.publish_status = true;
            } else if (element.publish_status == 'Archived') {
              element.publish_status = false;
            }
          });

          this.total_items = response.data.data.total;
        } else if (response.data.status == 0) {
          this.loaders.incident_list_loader = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true
        }
      }).catch((error) => {
        this.loaders.incident_list_loader = false;
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    },
    displayFullImage(item_image, flag) {
      this.image_dialog_box = true;
      this.flag = flag;
      this.image_path = item_image;
    },
    updateIncidentStatus(value, id) {
      this.incident_id = id;
      this.incident_status = value;
      // this.status_approval_dialog = true;
    },
    updateStatus(incident_status, incident_id) {
      this.loaders.approvalLoader = true;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/hide-incident-status`, {
            status: incident_status, incident_id: incident_id
          },
          {headers: this.$headers}).then((response) => {
        if (response.data.status == 1) {
          this.loaders.approvalLoader = false;
          // this.status_approval_dialog = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true
          this.getIncidentReports();
        } else if (response.data.status == 0) {
          this.loaders.approvalLoader = false;
          // this.status_approval_dialog = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true
        }
      }).catch((error) => {
        this.loaders.approvalLoader = false;
        // this.status_approval_dialog = false;
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    },
    showIncident(id) {
      this.startLoading();
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/show-incident/` + id, {
        headers: this.$headers,
      }).then((response) => {
        if (response.data.status == 1) {
          this.stopLoading();
          this.update_incident_object = response.data.data;
          this.update_incident_dialog = true;
        } else if (response.data.status == 0) {
          this.stopLoading();
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      }).catch((error) => {
        this.stopLoading();
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true;
      });
    },
    editIncident() {
      this.loaders.updateLoader = true;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-incident`,
          this.update_incident_object,
          {headers: this.$headers,})
          .then((response) => {
            if (response.data.status == 1) {
              this.update_incident_dialog = false;
              this.loaders.updateLoader = false;
              this.getIncidentReports();
            } else if (response.data.status == 0) {
              this.update_incident_dialog = false;
              this.loaders.updateLoader = false;
            }
          }).catch((error) => {
        this.loaders.updateLoader = false;
        this.update_incident_dialog = false;
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    },
    // activateShowDialog(id) {
    //   this.startLoading();
    //   this.is_liked = 0;
    //   axios.get(`${process.env.VUE_APP_API_URL}/api/v1/show-incident/` + id, {
    //     headers: this.$headers,
    //   }).then((response) => {
    //     if (response.data.status == 1) {
    //       this.stopLoading();
    //       this.show_incident_object = response.data.data;
    //       this.show_incident_object.full_name = this.show_incident_object.created_by_user.first_name + ' ' +
    //           this.show_incident_object.created_by_user.last_name;
    //       let line_array = [];
    //       this.show_incident_object.line_incidents.forEach((element) => {
    //         if (element.line_id == 1) {
    //           line_array.push("Central");
    //         } else if (element.line_id == 2) {
    //           line_array.push("Western");
    //         } else if (element.line_id == 3) {
    //           line_array.push("Harbour");
    //         } else if (element.line_id == 4) {
    //           line_array.push("Trans Harbour");
    //         } else if (element.line_id == 5) {
    //           line_array.push("Uran");
    //         } else if (element.line_id == 6) {
    //           line_array.push("Panvel-Vasai");
    //         } else if (element.line_id == 7) {
    //           line_array.push("Neral-Matheran");
    //         } else if (element.line_id == 8) {
    //           line_array.push("Pune-Lonavla");
    //         }
    //       });
    //
    //       this.show_incident_object.line_incidents_data = line_array.join(', ');
    //       this.show_incident_object.incidentTypeName = this.show_incident_object.incident_type.name;
    //       this.show_incident_object.stationName = this.show_incident_object.station_name.name;
    //       if(this.show_incident_object.incident_likes.length > 0){
    //         this.is_liked = 1;
    //       }else{
    //         this.is_liked = 0;
    //       }
    //       this.showIncidentDetailDialog = true;
    //     } else if (response.data.status == 0) {
    //       this.stopLoading();
    //       this.snackbar.message = response.data.message;
    //       this.snackbar.display = true;
    //     }
    //   }).catch((error) => {
    //     this.stopLoading();
    //     this.snackbar.message = "Something went wrong.";
    //     this.snackbar.display = true;
    //   });
    // },
    updateToggleStatus(publish_status, id) {
      let status;
      if (publish_status === true) {
        status = "Published";
      } else {
        status = "Archived";
      }
      this.updateStatus(status, id)
    },
    clearDate() {
      this.filters.affected_date = "";
    },
    deleteIncident: function () {
      this.loaders.delete_loading = true;
      let formData = new FormData()
      formData.append('incident_id', this.incident_id)

      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/delete-incident-status`, formData,
          {headers: this.$headers})
          .then(response => {
            this.loaders.delete_loading = false;
            if (response.data.status == 1) {
              this.delete_incident_box = false;
              this.getIncidentReports();
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            } else if (response.data.status == 0) {
              this.delete_incident_box = false;
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            }
          })
          .catch((error) => {
            this.loaders.delete_loading = false;
            this.snackbar.message = "Something went wrong.";
            this.snackbar.display = true;
          });
    },
    likeIncident(id) {
      let formData = new FormData();
      formData.append('incident_id', id);
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/web-incident-add-like`, formData,
          {headers: this.$headers,})
          .then(response => {
            if (response.data.status == 1) {
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
              this.activateShowDialog(id);
            }else if(response.data.status == 0){
              this.stopLoading();
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;

            }
          });
    },
    getComments(id){
      let formData = new FormData();
      formData.append('incident_id', id);

    }
  },
  mounted() {
    this.storage_path1 = process.env.VUE_APP_AZURE_STORAGE_URL + process.env.VUE_APP_AZURE_STORAGE_CONTAINER + "/";
  }
}
</script>
<style>
.disabled-title {
  pointer-events: none;
  color: #ada9a9 !important;
  background-color: #aaa8a8 !important;
  border-radius: 10px !important;
  /* Change to your desired disabled text color */
}

.switch {
  position: relative;
  display: inline-block;
  width: 55px;
  height: 32px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 20px;
  left: 5px;
  top: 5px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

/* include generated hidden field here */
input[type="checkbox"]:checked + input[type="hidden"] + .slider,
input[type="checkbox"]:checked + .slider {
  background-color: #2196F3;
}

/* include generated hidden field here */
input[type="checkbox"]:focus + input[type="hidden"] + .slider,
input[type="checkbox"]:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

/* include generated hidden field here */
input[type="checkbox"]:checked + input[type="hidden"] + .slider:before,
input[type="checkbox"]:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 30px;
}

.slider.round:before {
  border-radius: 40%;
}

.flatpickr-wrapper {
  position: relative;
}

.close-button {
  position: absolute;
  top: 50%;
  right: 10px; /* Adjust the right distance according to your preference */
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #999; /* Customize the color of the close (X) sign */
}
</style>

